import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const getAdminOneBom = createAsyncThunk(
    "/admin/get-one-bom",
    async (id) => {
        try {
            const myurl = `${V_URL}/believe/get-one-bom/${id}`;
            const response = await axios({
                method: "get",
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
                },
            });
            const data = response.data;
            if (data.success === true) {
                return data;
            } else {
                throw new Error(data.message || "BOM not found");
            }
        } catch (error) {
            console.error("Error in getAdminOneBom:", error);
            toast.error(error.response?.data?.message || "Error retrieving BOM details");
            throw error;
        }
    }
);

const getAdminOneBomSlice = createSlice({
    name: "getAdminOneBom",
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {
        resetGetAdminOneBom: (state) => {
            state.data = null;
            state.loading = false;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAdminOneBom.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAdminOneBom.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getAdminOneBom.rejected, (state, action) => {
                state.data = null;
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { resetGetAdminOneBom } = getAdminOneBomSlice.actions;
export default getAdminOneBomSlice.reducer;
